import {ServiceField} from "@/lib/constants/service.ts";

export const getRequiredError = (fieldName: string) => {
  if (fieldName === ServiceField.ADDRESS) {
    return "Please enter a valid address.";
  }

  return "This field is required.";
};
